import axiosInstance from "./axiosInstance";

export const searchNovaPostSettlements = async (query, { signal } = {}) => {
  const { data } = await axiosInstance.get("/nova-post/public/settlements", {
    params: { q: query },
    signal,
    timeout: 20000,
  });
  return Array.isArray(data?.items) ? data.items : [];
};

export const searchNovaPostPublicDivisions = async (
  { settlementId, settlementName, query, pointType },
  { signal } = {}
) => {
  const { data } = await axiosInstance.get("/nova-post/public/divisions", {
    params: {
      settlementId: settlementId || undefined,
      settlementName: settlementName || undefined,
      q: query,
      pointType: pointType || undefined,
    },
    signal,
    timeout: 30000,
  });
  return Array.isArray(data?.items) ? data.items : [];
};

export const validateNovaPostCheckoutDelivery = async (payload) => {
  const { data } = await axiosInstance.post(
    "/nova-post/public/validate-delivery",
    payload,
    { timeout: 30000 }
  );
  return data;
};
